/* ============================================================
 * run-them-together.js
 * Drives the "Pairings to Try" list in sections/run-them-together.liquid.
 *  - Each row's "Add +2" button carries the two real variant ids Liquid
 *    resolved for that pairing (data-variant-id-1/-2).
 *  - Clicking it calls into the Bundle Builder section elsewhere on the
 *    page via the small public API bundle-builder.js exposes on its own
 *    root element (`root.bundleBuilderApi`) — this file never reaches into
 *    Bundle Builder's internal state directly, and Bundle Builder doesn't
 *    know this file exists.
 *  - If there isn't room for both units, the API call fails (and Bundle
 *    Builder still runs its own existing shake/pulse feedback) and this
 *    file shows a small floating "pack is full" popup near the button that
 *    was clicked.
 * ============================================================ */
(function () {
  'use strict';

  /** The Bundle Builder section may or may not be on the page at all — every
   *  call site below is null-guarded against that. */
  function getBuilderApi() {
    const root = document.querySelector('[data-bundle-builder]');
    return root && root.bundleBuilderApi ? root.bundleBuilderApi : null;
  }

  /** Shows (or replaces) a single floating popup, positioned above the given
   *  anchor element and flipped below it if there isn't room above. Removes
   *  itself after a few seconds. */
  function showPopup(anchorEl, message) {
    const existing = document.querySelector('.pairing-popup');
    if (existing) existing.remove();

    const popup = document.createElement('div');
    popup.className = 'pairing-popup';
    popup.setAttribute('role', 'status');
    popup.textContent = message;
    document.body.appendChild(popup);

    const anchorRect = anchorEl.getBoundingClientRect();
    const popupRect = popup.getBoundingClientRect();

    let top = anchorRect.top - popupRect.height - 10;
    if (top < 8) top = anchorRect.bottom + 10;

    let left = anchorRect.left + anchorRect.width / 2 - popupRect.width / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - popupRect.width - 8));

    popup.style.top = top + 'px';
    popup.style.left = left + 'px';

    requestAnimationFrame(() => {
      popup.classList.add('is-visible');
    });

    setTimeout(() => {
      popup.classList.remove('is-visible');
      setTimeout(() => popup.remove(), 250);
    }, 3000);
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pairing-add]');
    if (!btn) return;

    const container = btn.closest('[data-pairings-full-message]');
    const message =
      (container && container.dataset.pairingsFullMessage) ||
      'Bundle is full, remove sticks before adding more.';

    // Note: data-variant-id-a/-b (letters, not -1/-2) — the dataset API only
    // auto-camelCases a hyphen followed by a letter; a hyphen followed by a
    // digit is left as a literal hyphen in the property name (e.g.
    // dataset['variantId-1']), so -1/-2 would never match a dot-accessed
    // property here.
    const id1 = btn.dataset.variantIdA;
    const id2 = btn.dataset.variantIdB;
    if (!id1 || !id2) return;

    const api = getBuilderApi();
    if (!api) return;

    const result = api.addVariants([id1, id2]);
    if (!result || !result.ok) {
      showPopup(btn, message);
    }
  });
})();
